module.exports = __webpack_public_path__ + "static/img/third.96cd0ff1.png";